<!-- PreviewBox.vue : ドラッグした時に現れる，予約範囲を示すボックス -->
<template lang="html">
  <div id="previewBox"
    :style="getStyle"
    @mousedown="mousedownHandler($event)"
    @mousemove="mousemoveHandler($event)"
    @mouseup="mouseupHandler($event)"
    @keyup.esc="$emit('keyup.esc')"
    v-if="hasHeight"
    >
    {{ $store.state.previewBox.start }} ~
    {{ $store.state.previewBox.end }}
    <br>
    <button type="button" @click="show_reservationpopup()" class="show_reservationpopup">予約を作成する</button><br>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  PREVIEWBOX_STYLE_UPDATE,
  PREVIEWBOX_HIDE_POPUP,
  RESERVATION_SHOW_POPUP
} from '@/vuex/mutation_types'

export default {
  name: 'preview-box',
  props: [
    'dragging'
  ],
  data () {
    return {
      state: this.$store.state.previewBox
    }
  },
  methods: {
    mousedownHandler (event) {
      this.$emit('pvmousedown', {
        e: {
          offsetY: event.offsetY + this.timeToPosition(this.state.start)
        },
        classroom: this.state.classroom
      })
    },
    show_reservationpopup () {
      this.$store.commit(PREVIEWBOX_HIDE_POPUP)
      this.$store.commit(RESERVATION_SHOW_POPUP)
    },
    mousemoveHandler (event) {
      this.$emit('pvmousemove', {
        e: {
          offsetY: event.offsetY + this.timeToPosition(this.state.start)
        },
        classroom: this.state.classroom
      })
    },
    mouseupHandler (event) {
      this.$emit('pvmouseup', {
        e: {
          offsetY: event.offsetY + this.timeToPosition(this.state.start)
        },
        classroom: this.state.classroom
      })
    },
    getUpdatedStyle () {
      const top = this.timeToPosition(this.$store.state.previewBox.start)
      const bottom = this.timeToPosition(this.$store.state.previewBox.end)
      const height = bottom - top
      const left = this.getLeftPosOfClassroom(this.$store.state.previewBox.classroom)
      let style = {
        top: top,
        bottom: bottom,
        height: height,
        left: left
      }
      return style
    }
  },
  computed: {
    ...mapGetters([
      'timeToPosition',
      'positionToTime',
      'getLeftPosOfClassroom'
    ]),
    hasHeight () {
      this.$store.commit(
        PREVIEWBOX_STYLE_UPDATE,
        this.getUpdatedStyle()
      )
      return this.$store.state.previewBox.style.height !== 0
    },
    getStyle () {
      const style = {
        top: this.$store.state.previewBox.style.top * this.$store.state.mobileHeightMagnification + 'px',
        left: this.$store.state.previewBox.style.left * this.$store.state.mobileWidthMagnification + 'px',
        bottom: this.$store.state.previewBox.style.bottom + 'px',
        height: this.$store.state.previewBox.style.height * this.$store.state.mobileHeightMagnification + 'px',
        width: this.$store.state.columnWidth * this.$store.state.mobileWidthMagnification + 'px'
      }
      return style
    }
  }
}
</script>

<style scoped>
#previewBox {
  box-sizing: border-box;
  position: absolute;
  margin: 0;
  padding: 0;
  background-color: white;
  border-style: dashed;
  border-color: #0065B3;
  z-index: 999;
}
button{
  font-size: 5vw;
}
.show_reservationpopup{
  background-color: rgba(41, 189, 140, 0.63);
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// SpPreviewBox.vue?dafe6dac